import { useState } from "react"
import { type ValidationError } from "../../Objects/Generics/Helps"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { AddtionalEntity } from "../../Objects/Addtional/AddtionalEntity"

export const useCreateAddtional = () => {
  const [name, setName] = useState("")

  const [description, setDescription] = useState("")

  const [value, setValue] = useState("")

  const [status, setStatus] = useState<EEnableStatusType>(EEnableStatusType.Active)

  const [addtional, setAddtional] = useState<AddtionalEntity | null>(null)

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value)
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)
  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setStatus(e.target.selectedIndex as EEnableStatusType)

  const handleInitialValue = (addtional: AddtionalEntity | null | undefined) => {
    if (addtional) {
      setAddtional(addtional)

      setValue(addtional.value)
      setName(addtional.name)
      setDescription(addtional.description)
      setStatus(addtional.status)
    }
  }

  const handleSubmitForm = (): AddtionalEntity | { errors: ValidationError[] } => {
    return new AddtionalEntity({
      id: addtional?.id,
      status: status,
      name: name,
      value: value,
      description: description,
    })
  }

  return {
    name,
    description,
    status,
    value,
    handleNameChange,
    handleDescriptionChange,
    handleValueChange,
    handleStatusChange,
    handleSubmitForm,
    handleInitialValue,
  }
}
